// eslint-disable-no-unused-vars
export enum Way {
    ASC = 'asc',
    DESC = 'desc',
}
